module.exports = __webpack_public_path__ + "static/media/KV1.d21e3354.svg";